
import Button from '@/components/buttons/Button.vue';
import BubbleIcon from '@/components/interface/BubbleIcon.vue';
import BottomSheet from '@/components/modal/BottomSheet.vue';
import BottomSheetInsert from '@/components/modal/BottomSheetInsert.vue';
import { withLoading } from '@/lib/composition/loading';
import { ButtonSize, buttonSizes } from '@/lib/enum/ButtonSizes';
import { Icon } from '@/lib/enum/Icon';
import { showInfo } from '@/plugins/ToastNotifications';
import { MenuItemType } from '@/types/propTypes';
import { viewport } from '@/util/windowFunctions';
import { PropType } from 'vue';

export default {
  name: 'ButtonMenu',
  components: {
    BottomSheetInsert,
    BottomSheet,
    Button,
    BubbleIcon,
  },
  props: {
    menu: {
      type: Array as () => MenuItemType[],
      default: () => [],
    },
    alignMenuX: {
      type: String,
      default: 'right',
      validator: (p) => ['left', 'right'].includes(p),
    },
    alignMenuY: {
      type: String,
      default: 'bottom',
      validator: (p) => ['top', 'bottom'].includes(p),
    },
    nudgeBottom: {
      type: Number,
      default: 0,
    },
    buttonColour: {
      type: String,
      default: 'white',
    },
    buttonSize: {
      type: String as PropType<ButtonSize>,
      default: 'md',
      validator: (p) => buttonSizes.includes(p),
    },
    buttonText: {
      type: String,
      default: '',
    },
    hideText: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    iconLeft: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    closeOnContentClick: {
      type: Boolean,
      default: true,
    },
    menuWidth: {
      type: Number,
      default: 80,
    },
    menuMaxHeight: {
      type: [String, Number],
      default: 'auto',
    },
    useBottomSheetOnMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Icon,
      viewport,
      open: false,
      actionInProgress: false,
    };
  },
  computed: {
    preparedMenu(): MenuItemType[] {
      return this.menu
        .filter((item) => !item.hide)
        .map((item) => ({
          ...item,
          ...((item.action || item.disabled) && {
            action: item.disabled
              ? () => this.onDisabledClick(item.disabled)
              : () => this.actionHandler(item.action),
          }),
        }));
    },
  },
  methods: {
    toggleMenu() {
      this.open = !this.open;
    },
    onDisabledClick(message: MenuItemType['disabled']) {
      if (typeof message === 'string' && message.length) {
        showInfo(message, this.$t('toastNotification.disabledAction'));
      }
    },
    async actionHandler(action: MenuItemType['action']) {
      if (this.actionInProgress) return;
      await withLoading(
        (v) => {
          this.actionInProgress = v;
        },
        async () => action(),
      )();
    },
  },
};
